module.exports = __webpack_public_path__ + "static/img/interpol.c55ffca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/interpol.png
// module id = /h3B
// module chunks = 1